import { ReactNode, useCallback, useRef, useState } from "react";
import './view.css'
import useDidMountEffect from "../functions.ts";
import TabLink from "./tab-link.tsx";

export default function View(props:{style?: React.CSSProperties, children: ReactNode}){
    return  <div 
            className="view"
        >
        <div className="view-inner" style={props.style}>
            {props.children}
            <TabLink/>
        </div>
    </div>;  
}    

export function ViewDialog(props:{style?: React.CSSProperties, children: ReactNode}){
    const [last_input, set_last_input] = useState<HTMLElement | undefined>(undefined);
    const viewRef = useCallback((node: HTMLElement | null) => {
        if (node !== null) {
            const last_element = node.querySelectorAll("[tabindex]");
            set_last_input(last_element[last_element.length -1]);
            console.log("last element", node, last_element);
        }
    }, []);

    return  <div 
        ref={viewRef}
        className="view"
        onBlur={(event)=>{
        //    if (event.target == last_input){
        //         const next_button = document.querySelector("#next-button");
        //         console.log("GO TO NEXT BUTTON",next_button);
        //         setTimeout(() => {
        //             next_button.focus();
        //         }, 400);
        //    }
        }}
    >
        <div className="view-inner view-dialog-inner view-dialog" style={props.style}>
            {props.children}
            <TabLink/>
        </div>
    </div>;  
}    

export function ViewCopy(props:{style?: React.CSSProperties, children: ReactNode}){
    return  <div className="view__copy-block" >{props.children}</div>;  
}    


export function P(props:{style?: React.CSSProperties, children: ReactNode}){
    return  <p className="view__copy" >{props.children}</p>;  
}    

export function H(props:{style?: React.CSSProperties, children: ReactNode}){
    return  <p role="heading" className="view__title" >{props.children}</p>;  
}    


export function ViewCopyLong(props:{style?: React.CSSProperties, children: ReactNode}){
    return  <p className="view__copy--long" >{props.children}</p>;  
}    